import React, { useState } from 'react';
import { LayoutDashboard, Receipt, FlaskConical, Menu, X } from 'lucide-react';
import ReportsDashboard from './ReportsDashboard';
import FinancialReport from './FinancialReport';
import StudyReports from '../StudyReports';
import BillingConsultationsReport from './BillingConsultationsReport';
import BillingStudiesReport from './BillingStudiesReport';
import './ReportsHub.css';

const ReportsHub = () => {
    const [activeTab, setActiveTab] = useState('dashboard');
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setSidebarOpen(false);
    };

    const renderContent = () => {
        switch (activeTab) {
            case 'dashboard': return <ReportsDashboard onNavigate={handleTabChange} />;
            case 'financial': return <FinancialReport />;
            case 'studies': return <StudyReports />;
            case 'billing-consultations': return <BillingConsultationsReport />;
            case 'billing-studies': return <BillingStudiesReport />;
            default: return <ReportsDashboard onNavigate={handleTabChange} />;
        }
    };

    const navItems = [
        { key: 'dashboard', icon: LayoutDashboard, label: 'General' },
        { key: 'financial', icon: Receipt, label: 'Finanzas' },
        { key: 'studies', icon: FlaskConical, label: 'Estudios' },
        { key: 'billing-consultations', icon: Receipt, label: 'Cobranza Consulta' },
        { key: 'billing-studies', icon: FlaskConical, label: 'Cobranza Estudios' },
    ];

    return (
        <div className="reports-hub">
            {/* Mobile overlay */}
            <div
                className={`sidebar-overlay ${sidebarOpen ? 'visible' : ''}`}
                onClick={() => setSidebarOpen(false)}
            />

            <aside className={`reports-sidebar ${sidebarOpen ? 'open' : ''}`}>
                <div className="sidebar-header">
                    <h2>📊 Centro de Reportes</h2>
                </div>
                <nav className="sidebar-nav">
                    {navItems.map(({ key, icon: Icon, label }) => (
                        <button
                            key={key}
                            className={`nav-item ${activeTab === key ? 'active' : ''}`}
                            onClick={() => handleTabChange(key)}
                        >
                            <Icon size={20} />
                            <span>{label}</span>
                        </button>
                    ))}
                </nav>
            </aside>

            <main className="reports-content">
                {renderContent()}
            </main>

            {/* Mobile FAB */}
            <button
                className="sidebar-mobile-toggle"
                onClick={() => setSidebarOpen(!sidebarOpen)}
                aria-label="Toggle navigation"
            >
                {sidebarOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
        </div>
    );
};

export default ReportsHub;
